/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// @mui icons
import Icon from "@mui/material/Icon";
// import TryOutlinedIcon from "@mui/icons-material/TryOutlined";
import CompanyList from "pages/CompanyList";
import CreateNewCompany from "pages/CreateNewCompany";
// import SubscriptionList from "pages/subscriptionList";
import Users from "pages/users";
import CacheManager from "pages/CacheManager";
import KPI from "pages/KPI";
import Home from "pages/Home";
import Performance from "pages/Performance";
import Settings from "pages/settings";
import ProfileSettings from "pages/Profile-Settings";
import Leaderboard from "pages/Leaderboard";
import Reports from "pages/Coachup/Reports";
import CoachUpTemplates from "pages/Coachup/Templates";
import { PERMISSIONS_NAME, MODULES } from "lib/constants";
import TemplateForm from "pages/Coachup/Templates/components/TemplateForm";
import ViewReport from "pages/Coachup/Reports/components/ViewReport";
import Builder from "pages/Compete/Builder";
import Competitions from "pages/Compete/Competitions";
import CompetitionForm from "pages/Compete/Builder/components/CompetitionForm";
import EmailVerification from "pages/authentication/email-verification";
import Workspace from "pages/authentication/workspace";
import SubscriptionPlans from "pages/subscriptionPlans/SubscriptionPlans";
import Snapshot from "pages/Snapshot";
import UsersBulkUpload from "pages/settings/UsersBulkUpload";
import Integrations from "pages/settings/Integrations";
import Crons from "pages/Crons";
import Hierarchy from "pages/Hierarchy";
import IntegrationEvents from "pages/IntegrationEvents";
import ModulesManagement from "pages/ModulesManagement";
import KPICategorization from "pages/KPICategorization";
import AssistantOutlinedIcon from "@mui/icons-material/AssistantOutlined";
import TrophyCabinet from "pages/TrophyCabinet";
// import SalesforceCb from "pages/oauth/cb/Salesforce";
// import SlackCb from "pages/oauth/cb/Slack";
import OauthCb from "pages/oauth/cb";
// import Alys from "pages/Alys";
import Insights from "pages/Insights";
import { USER_ROLE, CORPORATE_ADMIN } from "./utils/Roles/Roles";

// const token = localStorage.getItem("token");

const routes = [];

// if (token !== null && token.length > 0) {
// check type
// if (user === "admin" || user === "Admin") {
routes.push(
  {
    type: "nocollapase",
    name: "Dashboard",
    key: "home",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    route: "/home",
    component: <Home />,
    accessby: [USER_ROLE],
  },
  {
    type: "nocollapase",
    name: "Registrations",
    key: "registrations",
    icon: <Icon fontSize="medium">apps</Icon>,
    route: "/registrations",
    component: <CompanyList />,
    accessby: [CORPORATE_ADMIN],
  },
  {
    type: "nocollapase",
    name: "Create New Company",
    key: "create-new-company",
    icon: <Icon fontSize="medium">playlist_add</Icon>,
    route: "/create-new-company",
    component: <CreateNewCompany />,
    accessby: [CORPORATE_ADMIN],
  },
  // {
  //   type: "nocollapase",
  //   name: "Subscriptions",
  //   key: "subscriptions",
  //   icon: <Icon fontSize="medium">list_alt</Icon>,
  //   route: "/subscriptions",
  //   component: <SubscriptionList />,
  //   accessby: [CORPORATE_ADMIN],
  // },
  {
    type: "nocollapase",
    name: "Snapshot",
    key: "snapshot",
    icon: <Icon fontSize="medium">assessment</Icon>,
    route: "/snapshot",
    component: <Snapshot />,
    accessby: [CORPORATE_ADMIN],
  },
  {
    type: "nocollapase",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="medium">group</Icon>,
    route: "/users",
    component: <Users />,
    accessby: [CORPORATE_ADMIN],
  },
  {
    type: "nocollapase",
    name: "Cache",
    key: "cache",
    icon: <Icon fontSize="medium">storage</Icon>,
    route: "/cache",
    component: <CacheManager />,
    accessby: [CORPORATE_ADMIN],
  },
  {
    type: "nocollapase",
    name: "Crons",
    key: "crons",
    icon: <Icon fontSize="medium">event_repeat</Icon>,
    route: "/crons",
    component: <Crons />,
    accessby: [CORPORATE_ADMIN],
  },
  {
    type: "nocollapase",
    name: "Hierarchy",
    key: "hierarchy",
    icon: <Icon fontSize="medium">reduce_capacity</Icon>,
    route: "/hierarchy",
    component: <Hierarchy />,
    accessby: [CORPORATE_ADMIN],
  },
  {
    type: "nocollapase",
    name: "Integration Events",
    key: "integration-events",
    icon: <Icon fontSize="medium">bar_chart</Icon>,
    route: "/integration-events",
    component: <IntegrationEvents />,
    accessby: [CORPORATE_ADMIN],
  },
  {
    type: "nocollapase",
    name: "Modules Management",
    key: "modules-management",
    icon: <Icon fontSize="medium">tune</Icon>,
    route: "/modules-management",
    component: <ModulesManagement />,
    accessby: [CORPORATE_ADMIN],
  },
  {
    type: "nocollapase",
    name: "KPI Categorization",
    key: "kpi-categorization",
    icon: <Icon fontSize="medium">data_thresholding</Icon>,
    route: "/kpi-categorization",
    component: <KPICategorization />,
    accessby: [CORPORATE_ADMIN],
  },
  {
    type: "nocollapase",
    name: "Performance",
    key: "performance",
    icon: <Icon fontSize="medium">data_exploration</Icon>,
    route: "/performance",
    component: <Performance />,
    accessby: [USER_ROLE],
  },
  {
    type: "nocollapase",
    name: "Leaderboard",
    key: "leaderboard",
    icon: <Icon fontSize="medium">leaderboard</Icon>,
    route: "/leaderboard",
    component: <Leaderboard />,
    accessby: [USER_ROLE],
    module: MODULES.LEADERBOARD,
  },
  {
    type: "collapse",
    name: "Compete+",
    key: "compete",
    icon: <Icon fontSize="medium">local_police</Icon>,
    route: "/compete",
    // component: <Compete />,
    accessby: [USER_ROLE],
    module: MODULES.COMPETITIONS,
    collapse: [
      {
        name: "Competitions",
        key: "competitions",
        route: "/compete/competitions",
        component: <Competitions />,
        accessby: [USER_ROLE],
        module: MODULES.COMPETITIONS,
      },
      {
        name: "Competition Builder",
        key: "builder",
        permissionName: [
          PERMISSIONS_NAME.COMPETE_UNRANKED,
          PERMISSIONS_NAME.COMPETE_TREMENDOUS_PAYOUT,
        ],
        route: "/compete/builder",
        component: <Builder />,
        accessby: [USER_ROLE],
        module: MODULES.COMPETITIONS,
      },
    ],
  },
  {
    type: "collapse",
    name: "Coach Up",
    key: "coach",
    route: "coach",
    icon: <Icon fontSize="medium">moving</Icon>,
    accessby: [USER_ROLE],
    module: MODULES.SALES_COACHING,
    collapse: [
      {
        name: "Reports",
        key: "reports",
        route: "/coach/reports",
        component: <Reports />,
        accessby: [USER_ROLE],
        module: MODULES.SALES_COACHING,
      },
      {
        name: "Templates",
        key: "templates",
        permissionName: PERMISSIONS_NAME.MANAGE_COACHUP,
        route: "/coach/templates",
        component: <CoachUpTemplates />,
        accessby: [USER_ROLE],
        module: MODULES.SALES_COACHING,
      },
    ],
  },
  {
    name: "KPIs",
    key: "kpis",
    route: "/kpi",
    component: <KPI />,
    accessby: [USER_ROLE],
    permissionName: PERMISSIONS_NAME.MANAGE_KPIS,
  },
  {
    name: "Templates",
    key: "templates",
    route: "/kpi/templates",
    component: <KPI />,
    accessby: [USER_ROLE],
    permissionName: PERMISSIONS_NAME.MANAGE_KPIS,
  },
  {
    name: "Manage Users",
    key: "manage-user-kpis",
    route: "/kpi/manage-user-kpis",
    component: <KPI />,
    accessby: [USER_ROLE],
    permissionName: PERMISSIONS_NAME.MANAGE_KPIS,
  },
  {
    name: "Manage KPIs",
    key: "manage-kpis",
    route: "/kpi/manage-kpis",
    component: <KPI />,
    accessby: [USER_ROLE],
    permissionName: PERMISSIONS_NAME.MANAGE_KPIS,
  },
  // {
  //   type: "nocollapase",
  //   name: "Alys",
  //   key: "alys",
  //   icon: "custom",
  //   iconName: "AlysIcon",
  //   route: "/alys/chat",
  //   component: <Alys />,
  //   accessby: [USER_ROLE],
  //   module: MODULES.ALYS,
  // },
  {
    type: "nocollapase",
    name: "Insights",
    key: "hub",
    icon: <AssistantOutlinedIcon />,
    route: "/hub",
    component: <Insights />,
    accessby: [USER_ROLE],
    module: MODULES.INSIGHTS,
  },
  {
    name: "Profile Settings",
    key: "profile-settings",
    route: "/profile-settings",
    component: <ProfileSettings />,
    accessby: [USER_ROLE, CORPORATE_ADMIN],
  },
  {
    name: "Trophy Cabinet",
    key: "trophy-cabinet",
    route: "/trophy-cabinet",
    component: <TrophyCabinet />,
    accessby: [USER_ROLE],
  },
  {
    name: "Templates",
    key: "templates",
    permissionName: PERMISSIONS_NAME.MANAGE_COACHUP,
    route: "/coach/templates/add",
    component: <TemplateForm />,
    accessby: [USER_ROLE],
    module: MODULES.SALES_COACHING,
  },
  {
    name: "Templates",
    key: "templates",
    permissionName: PERMISSIONS_NAME.MANAGE_COACHUP,
    route: "/coach/templates/edit/:id",
    component: <TemplateForm />,
    accessby: [USER_ROLE],
    module: MODULES.SALES_COACHING,
  },
  {
    name: "Templates",
    key: "templates",
    permissionName: PERMISSIONS_NAME.MANAGE_COACHUP,
    route: "/coach/templates/copy/:id",
    component: <TemplateForm />,
    accessby: [USER_ROLE],
    module: MODULES.SALES_COACHING,
  },
  {
    name: "Templates",
    key: "templates",
    permissionName: PERMISSIONS_NAME.MANAGE_COACHUP,
    route: "/coach/templates/user/edit/:id",
    component: <TemplateForm />,
    accessby: [USER_ROLE],
    module: MODULES.SALES_COACHING,
  },
  {
    name: "Reports",
    key: "reports",
    route: "/coach/reports/view",
    component: <ViewReport />,
    accessby: [USER_ROLE],
    module: MODULES.SALES_COACHING,
  },
  {
    name: "Reports",
    key: "reports",
    permissionName: PERMISSIONS_NAME.MANAGE_COACHUP,
    route: "/coach/reports/user/:id",
    component: <ViewReport />,
    accessby: [USER_ROLE],
    module: MODULES.SALES_COACHING,
  },
  {
    name: "Builder",
    key: "builder",
    permissionName: PERMISSIONS_NAME.MANAGE_COMPETITIONS,
    route: "/compete/builder/add",
    component: <CompetitionForm />,
    accessby: [USER_ROLE],
    module: MODULES.COMPETITIONS,
  },
  {
    name: "Builder",
    key: "builder",
    permissionName: PERMISSIONS_NAME.MANAGE_COMPETITIONS,
    route: "/compete/builder/edit/:id",
    component: <CompetitionForm />,
    accessby: [USER_ROLE],
    module: MODULES.COMPETITIONS,
  },
  {
    name: "Builder",
    key: "builder",
    permissionName: PERMISSIONS_NAME.MANAGE_COMPETITIONS,
    route: "/compete/builder/copy/:id",
    component: <CompetitionForm />,
    accessby: [USER_ROLE],
    module: MODULES.COMPETITIONS,
  },
  {
    name: "Settings",
    key: "settings",
    route: "/settings",
    component: <Settings />,
    accessby: [USER_ROLE],
  },
  {
    name: "Settings",
    key: "settings",
    route: "/settings/integrations/:integration",
    component: <Integrations />,
    accessby: [USER_ROLE],
  },
  {
    name: "Settings",
    key: "settings",
    route: "/settings/users/bulk-upload",
    component: <UsersBulkUpload />,
    accessby: [USER_ROLE],
  },
  {
    name: "Oauth Callback",
    key: "oauthCb",
    route: "/oauth/cb/*",
    component: <OauthCb />,
    accessby: [USER_ROLE],
  },
  {
    name: "Email Verification",
    key: "verify-email",
    route: "/verify-email",
    component: <EmailVerification />,
    accessby: [USER_ROLE],
  },
  {
    name: "Workspace",
    key: "workspace",
    route: "/workspace",
    component: <Workspace />,
    accessby: [USER_ROLE],
  },
  {
    name: "Subscription Plans",
    key: "subscription-plans",
    route: "/subscription-plans",
    component: <SubscriptionPlans />,
    accessby: [USER_ROLE],
  }
);

const bottomRoutes = [
  {
    type: "button",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="medium">notifications-active-icon</Icon>,
    accessby: [USER_ROLE],
  },
  {
    type: "button",
    name: "Settings",
    key: "settings",
    icon: <Icon fontSize="medium">settings-cog-icon</Icon>,
    accessby: [USER_ROLE],
  },
];

export { routes, bottomRoutes };
